export enum GradeByType {
  Assignment = 'assignment',
  Lesson = 'lesson',
  Section = 'section',
};

export type GradingBy = GradeByType.Assignment | GradeByType.Lesson | GradeByType.Section;
